import React, { useState } from "react"
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels"
import { useAppContext } from "../context/appContext"
import NewChatComponent from "./ChatComponent/newChatComponent"

const PersistentWrapper = ({ children }) => {
  const { state, setShowNewChatWindow } = useAppContext()
  const [panelWidths, setPanelWidths] = useState([35, 65])

  const handleResize = (index, newSize) => {
    const newWidths = [...panelWidths]
    newWidths[index] = newSize
    setPanelWidths(newWidths)
  }

  return (
    <>
      {state?.showNewChatWindow && !state.isMobile && !state.isTab ? (
        <PanelGroup
          direction="horizontal"
          className="whole-website-wrapper"
          id="group-1"
        >
          <Panel
            order={1}
            id="left"
            defaultSize={panelWidths[0]}
            minSize={30}
            maxSize={40}
            className="chat-panel"
            onResize={newSize => handleResize(0, newSize)}
          >
            <div
              className="website-new-chat-wrapper"
              style={{
                paddingTop: "80px",
                position: "fixed",
                width: `${100 - panelWidths[1]}%`,
                zIndex: "1",
              }}
            >
              <NewChatComponent
                showChatWindow={state.showNewChatWindow}
                userMessage={state.homepageMessage}
                setShowChatWindow={setShowNewChatWindow}
              />
            </div>
          </Panel>
          <PanelResizeHandle className="panel-seperator" />
          <Panel
            order={2}
            defaultSize={panelWidths[1]}
            minSize={60}
            id="right"
            onResize={newSize => handleResize(1, newSize)}
          >
            <div className="website-wrapper">{children}</div>
          </Panel>
        </PanelGroup>
      ) : (
        <>{children}</>
      )}
    </>
  )
}

export default PersistentWrapper
